// extracted by mini-css-extract-plugin
export default {"title":"CurrentCoverage_title__40Iyg","link":"CurrentCoverage_link__TKJ0u"};